import React from "react";
import './Footer.css';

export default function Footer(){
    return (
        <div className="footer">
            <div className="footer--container">

                <div className="back--to--top">
                    <h3>Back to top</h3>
                </div>

                <div className="footer--main--content">
                    <div className="know--us footer-column">
                        <h3>Get to Know Us</h3>
                        <a href="https://www.aboutamazon.in/?utm_source=gateway&utm_medium=footer">About Us</a>
                        <a href="https://www.amazon.jobs/en/?utm_source=gateway&utm_medium=footer">Careers</a>
                        <a href="https://press.aboutamazon.in/?utm_source=gateway&utm_medium=footer">Press Releases</a>
                        <a href="https://www.amazon.in/b?ie=UTF8&node=8872558031&ref_=footer_cares">Amazon Cares</a>
                        <a href="https://www.amazon.in/technology/?utm_source=gateway&utm_medium=footer">Amazon and COVID-19</a>
                    </div>

                    <div className="connect--us footer-column">
                        <h3>Connect with Us</h3>
                        <a href="https://www.facebook.com/AmazonIN/">Facebook</a>
                        <a href="https://www.twitter.com/amazonIN/">Twitter</a>
                        <a href="https://www.instagram.com/amazondotin/">Instagram</a>
                    </div>

                    <div className="make--money--us footer-column">
                        <h3>Make Money with Us</h3>
                        <a href="https://sell.amazon.in/?utm_source=gateway&utm_medium=footer">Sell on Amazon</a>
                        <a href="https://affiliate-program.amazon.in/?utm_source=gateway&utm_medium=footer">Become an Affiliate</a>
                        <a href="https://advertising.amazon.in/?utm_source=gateway&utm_medium=footer">Advertise Your Products</a>
                        <a href="https://www.amazon.in/gp/seller-account/mm-summary-page.html?ie=UTF8&ld=AZINSOAFooter">Amazon Pay on Merchants</a>
                        <a href="https://www.amazon.in/b?ie=UTF8&node=6967393031&ref_=footer_mobapp">Become an Author</a>
                        <a>Sell under Amazon Accelerator</a>
                        <a>Amazon Global Selling</a>
                        <a>Fulfilment by Amazon</a>
                        <a>Advertise Your Products</a>
                    </div>

                    <div className="let--us--help footer-column">
                        <h3>Let Us Help You</h3>
                        <a href="https://www.amazon.in/gp/help/customer/display.html?ie=UTF8&nodeId=200507590&ref_=footer_covid">COVID-19 and Amazon</a>
                        <a href="https://www.amazon.in/gp/css/homepage.html?ie=UTF8&ref_=footer_ya">Your Account</a>
                        <a href="https://www.amazon.in/gp/help/customer/display.html?ie=UTF8&nodeId=GDFU3JS5AL6SYHRD&ref_=footer_covid">Returns Centre</a>
                        <a href="https://www.amazon.in/gp/help/customer/display.html?ie=UTF8&nodeId=201083470&ref_=footer_gw_m_b_he">100% Purchase Protection</a>
                        <a href="https://www.amazon.in/gp/BIT/ref=footer_bit_v2_us_A0029?bitCampaignCode=A0029">Amazon App Download</a>
                        <a href="https://www.amazon.in/gp/BIT/ref=footer_bit_v2_us_A0010?bitCampaignCode=A0010">Amazon Assistant Download</a>
                        <a href="https://www.amazon.in/gp/help/customer/display.html?ie=UTF8&nodeId=200507590&ref_=footer_covid">Help</a>
                    </div>
                </div>

                <div className="underline"></div>


                <div className="footer--bottom">

                    <div className="footer--bottom--left">
                        <img src="http://pngimg.com/uploads/amazon/amazon_PNG11.png" alt=""></img>
                    </div>

                    <div className="footer--bottom--center">
                        <a href="https://www.amazon.com.au/ref=footer_au">Australia</a>
                        <a href="https://www.amazon.com.br/ref=footer_br">Brazil</a>
                        <a href="https://www.amazon.ca/ref=footer_ca">Canada</a>
                        <a href="https://www.amazon.cn/ref=footer_cn">China</a>
                        <a href="https://www.amazon.fr/ref=footer_fr">France</a>
                        <a href="https://www.amazon.de/ref=footer_de">Germany</a>
                        <a href="https://www.amazon.it/ref=footer_it">Italy</a>
                        <a href="https://www.amazon.co.jp/ref=footer_jp">Japan</a>
                        <a href="https://www.amazon.com.mx/ref=footer_mx">Mexico</a>
                        <a href="https://www.amazon.nl/ref=footer_nl">Netherlands</a>
                        <a href="https://www.amazon.sg/ref=footer_sg">Singapore</a>
                        <a href="https://www.amazon.es/ref=footer_es">Spain</a>
                        <a href="https://www.amazon.com.tr/ref=footer_tr">Turkey</a>
                        <a href="https://www.amazon.ae/ref=footer_ae">United Arab Emirates</a>
                        <a href="https://www.amazon.co.uk/ref=footer_uk">United Kingdom</a>
                        <a href="https://www.amazon.com/ref=footer_us">United States</a>
                    </div>
                    
                </div>


                <div className="footer--bottom--bottom">

                    <div className="footer--bottom--bottom--left">
                        <div className="footer--bottom-bottom-column">
                            <div className="footer--bottom-bottom-row">
                                <h4>AbeBooks</h4>
                                <a className="padd">Books, art</a>
                                <a className="padd">& collectibles</a>
                            </div>

                            <div className="footer--bottom-bottom-row">
                                <h4>Shopbop</h4>
                                <a className="padd">Designer</a>
                                <a className="padd">Fashion Brands</a>
                            </div>
                        </div>

                        <div className="footer--bottom-bottom-column">
                            <div className="footer--bottom-bottom-row">
                                <h4>Amazon Web Services</h4>
                                <a className="padd">Scalable Cloud</a>
                                <a className="padd">Computing Services</a>
                            </div>

                            <div className="footer--bottom-bottom-row">
                                <h4>Prime Now</h4>
                                <a className="padd">2-Hour Delivery</a>
                                <a className="padd">on Everyday Items</a>
                            </div>
                        </div>

                        <div className="footer--bottom-bottom-column">
                            <div className="footer--bottom-bottom-row">
                                <h4>Audible</h4>
                                <a className="padd">Download</a>
                                <a className="padd">Audio Books</a>
                            </div>

                            <div className="footer--bottom-bottom-row">
                                <h4>Amazon Prime Music</h4>
                                <a className="padd">70 million songs, ad-free</a>
                                <a className="padd">Over 9 million podcast episodes</a>
                            </div>
                        </div>

                        <div className="footer--bottom-bottom-column">
                            <div className="footer--bottom-bottom-row">
                                <h4>DPReview</h4>
                                <a className="padd">Digital</a>
                                <a className="padd">Photography</a>
                            </div>

                            <div className="footer--bottom-bottom-row">
                                <h4>Amazon Prime Video</h4>
                                <a className="padd">Prime Video</a>
                                <a className="padd">in India</a>
                            </div>
                        </div>

                        <div className="footer--bottom-bottom-column">
                            <div className="footer--bottom-bottom-row">
                                <h4>IMDb</h4>
                                <a className="padd">Movies, TV</a>
                                <a className="padd">& Celebrities</a>
                            </div>
                        </div>

                    </div>

                    <div className="footer--bottom--bottom--right">
                        <div className="privacy--notice">
                            <a href="https://www.amazon.in/gp/help/customer/display.html?ie=UTF8&nodeId=200545940&ref_=footer_gw_m_b_he">Conditions of Use & Sale</a>
                            <a href="https://www.amazon.in/gp/help/customer/display.html?ie=UTF8&nodeId=200534380&ref_=footer_privacy">Privacy Notice</a>
                            <a href="https://www.amazon.in/gp/help/customer/display.html?ie=UTF8&nodeId=200534390&ref_=footer_iba">Interest-Based Ads</a>
                        </div>

                        <h4>© 1996-2021, Amazon.com, Inc. or its affiliates</h4>

                    </div>

                </div>
                
            </div>
        </div>
    )
}